import { Box, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { PlanType, RenewalOptions, Tier } from "../../models";
import { useData } from "../../utils/useData";
import { VariantStyleDictionary } from "../shared/AccountSummary/VariantStyleDictionary";

type PublicTransportAccountSummaryData = {
  alphanumericId: string;
  name: string;
  tiers: Tier[];
  serviceSectorIds: string[];
  planType: PlanType;
  renewalOptions: RenewalOptions;
};

export const PublicTransportAccountSummary: FC<{
  employerAlphanumericId: string;
  planInfo: PublicTransportAccountSummaryData;
}> = ({ employerAlphanumericId, planInfo }) => {
  const { serviceSectors } = useData();

  var { detailsListItemStyle, sectionHeaderStyle } =
    VariantStyleDictionary["full"];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography>
        The following details need to be used when setting up your payroll
        platform to participate in Public Transport salary election.
      </Typography>

      <Grid container item display="flex">
        <Grid item xs={6}>
          <Typography fontWeight={600}>Bank Account</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography textAlign="left">02-0278-0337708-003</Typography>
        </Grid>
      </Grid>

      <Grid container item display="flex">
        <Grid item xs={6}>
          <Typography fontWeight={600}>Particulars</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{employerAlphanumericId}</Typography>
        </Grid>
      </Grid>

      <Grid container item display="flex">
        <Grid item xs={6}>
          <Typography fontWeight={600}>Code</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{planInfo.alphanumericId}</Typography>
        </Grid>
      </Grid>

      <Grid container item display="flex">
        <Grid item xs={6}>
          <Typography fontWeight={600}>Reference</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            This will be the Employee ID generated from payroll. See our{" "}
            <a
              href="https://help-customer.extraordinarypay.com/hc/en-gb/articles/12994638036367-Public-Transport-Allowance-employee-set-up"
              target="_blank"
              rel="noreferrer"
            >
              Help Center
            </a>{" "}
            for more info.
          </Typography>
        </Grid>
      </Grid>

      <Typography sx={sectionHeaderStyle} mt={2}>
        Restrictions
      </Typography>
      <Box display="flex" flexDirection="column">
        <Box sx={detailsListItemStyle}>
          <Typography>
            {
              serviceSectors.data?.items.find(
                (x) => x.id === planInfo.serviceSectorIds[0]
              )?.name
            }{" "}
            Service Sector
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
